import StaffListVerticalTab from "../../../components/business/staff/staffListVerticalTab";
import Portal from "../../../../../platform/pages/business/portal"; 
const StaffPortal = (props: any) => {
  return <Portal TabComponent={StaffListVerticalTab} title ={"Team members"} props= {props} />;
};
export default StaffPortal;
